import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/NewsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Common/CommonTaile.tsx");
